import lodashGet from 'lodash/get';
import { api as masterApi } from '@/api/api';
import { apis, inWindow } from '@/config';
import { locationHelper } from '@/api/util/location_helper';
export class DBRetryInterceptor {
    constructor(interceptors) {
        this.dbApi = masterApi.requireLogicalApi(apis.dbInterfaceApiImpl);
        this.enableRetryApis = ['getByRangeCondition', 'getByEqCondition', 'getTableCount', 'getById', 'getByIds', 'getByIndexIds'];
        this.apilist = ['getByRangeCondition', 'getByEqCondition', 'getByIndexIds', 'getByIds'];
        this.systemApi = masterApi.getSystemApi();
        this.dataTrackerApi = masterApi.requireLogicalApi(apis.dataTrackerApiImp);
        this.loggerApi = masterApi.requireLogicalApi(apis.loggerApiImpl);
        if (inWindow() && !locationHelper.isMainPage()) {
            DBRetryInterceptor.warningLimit = 100;
        }
        const [, interceptor] = interceptors;
        interceptor.use({
            namespace: apis.dbInterfaceApiImpl,
            type: 'error',
            resolve: async (response) => {
                setTimeout(() => {
                    this.trackLog(response);
                }, 0);
                return response;
            },
            reject: async (error) => {
                const account = lodashGet(error, 'config.account', '');
                if (this.systemApi.getCurrentUser() && this.systemApi.getCurrentUser().accountMd5 !== account) {
                    throw error;
                }
                const namespace = lodashGet(error, 'config.namespace', '');
                const errMsg = lodashGet(error, 'message', typeof error === 'string' ? error : '');
                const apiname = lodashGet(error, 'config.apiname', '');
                const $tempMethod = this.dbApi[`_$${apiname}`];
                const BridgeErrorDesc = ['BG_WIN_UNRESPONSE', 'INVALD_ACCOUNT_NOACCOUNT', 'BG_WIN_NOT_EXIST'];
                const enableRetryError = BridgeErrorDesc.some(reason => errMsg.indexOf(reason) !== -1) || (BridgeErrorDesc.includes('API_RESPONSE_TIMEOUT') && this.enableRetryApis.includes(apiname));
                const enableRetry = namespace === apis.dbInterfaceApiImpl && typeof $tempMethod === 'function' && enableRetryError;
                if (!enableRetry) {
                    throw error;
                }
                const args = lodashGet(error, 'config.args', []);
                return this.dbApi[`_$${apiname}`](...args);
            },
        });
    }
    eject() { }
    trackLog(response) {
        const namespace = lodashGet(response, 'config.namespace', '');
        const apiname = lodashGet(response, 'config.apiname', '');
        if (namespace !== apis.dbInterfaceApiImpl || !this.apilist.includes(apiname)) {
            return;
        }
        const dbName = lodashGet(response, 'config.args[0].dbName', '');
        const tableName = lodashGet(response, 'config.args[0].tableName', '');
        const count = lodashGet(response, 'data.length', 0);
        if (typeof count !== 'number' || count < DBRetryInterceptor.warningLimit) {
            return;
        }
        let enableRecord = false;
        let argsCount = 0;
        switch (apiname) {
            case 'getByRangeCondition': {
                argsCount = lodashGet(response, 'config.args[0].adCondition.args.length', 0);
                break;
            }
            case 'getByEqCondition': {
                argsCount = lodashGet(response, 'config.args[0].adCondition.args.length', 0);
                break;
            }
            case 'getByIndexIds': {
                argsCount = lodashGet(response, 'config.args[2].length', 0);
                break;
            }
            case 'getByIds': {
                argsCount = lodashGet(response, 'config.args[1].length', 0);
                break;
            }
            default:
                break;
        }
        enableRecord = typeof argsCount === 'number' && argsCount >= 1;
        if (!enableRecord) {
            return;
        }
        this.dataTrackerApi.track('pc_db_exceed_thousand', {
            dbname: dbName,
            tablename: tableName,
            apiname,
            limit: DBRetryInterceptor.warningLimit,
            count: Math.round(count / DBRetryInterceptor.warningLimit),
            arglen: Math.round(argsCount / DBRetryInterceptor.warningLimit),
        });
        this.loggerApi.track('pc_db_exceed_thousand_detail', {
            params: lodashGet(response, 'config', {}),
            count,
        });
    }
}
DBRetryInterceptor.warningLimit = 1000;
